import { LoadingOverlay } from '@mantine/core';

import { AuthenticationModuleClientType } from '../../../../types';

export const UnauthorizedPage: AuthenticationModuleClientType['UnauthorizedPage'] = () => {
  return <LoadingOverlay visible />;
};
